/* Circular · footer signup.
   In assets/ rather than inline in cx-footer.liquid: an inline <script> inside a section
   is parsed by Shopify's Liquid/HTML parser, and that is what made this section emit no
   markup at all — the same failure the navbar had. As an asset nothing parses it.

   Config comes from data attributes on the <footer data-cxf> element. */
(function(){
var root=document.querySelector('[data-cxf]');
if(!root) return;
var COMPANY=root.getAttribute('data-cxf-company')||'', LIST=root.getAttribute('data-cxf-list')||'';
var f=document.querySelector('[data-cxf-form]'); if(!f) return;
var msg=document.querySelector('[data-cxf-msg]');
var btn=f.querySelector('button');
function say(t){ if(msg) msg.textContent=t; }
if(!COMPANY||!LIST){ f.addEventListener('submit',function(e){e.preventDefault();say('Signup is not configured yet.')}); return; }
f.addEventListener('submit',function(e){
e.preventDefault();
var input=f.querySelector('input'), v=input.value.trim();
if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ say('That email address does not look right.'); return; }
btn.disabled=true; say('Subscribing\u2026');
fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+COMPANY,{
method:'POST',
headers:{'Content-Type':'application/json','revision':'2024-10-15'},
body:JSON.stringify({data:{type:'subscription',attributes:{
profile:{data:{type:'profile',attributes:{email:v}}}},
relationships:{list:{data:{type:'list',id:LIST}}}}})
}).then(function(r){
btn.disabled=false;
if(r.ok||r.status===202){ f.reset(); say(root.getAttribute('data-cxf-ok')||'You are on the list.'); try{ if(window.ttq) ttq.track('Subscribe'); if(window.fbq) fbq('track','Lead'); }catch(err){} }
else { say('That did not go through. Please email support@circular.xyz and we will add you.'); }
}).catch(function(){
btn.disabled=false;
say('That did not go through. Please email support@circular.xyz and we will add you.');
});
});
})();
